import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import swal from 'sweetalert2';
import { HttpService } from 'app/core/http/http.service';
import { NotificationService } from 'app/shared/utils/notification.service';
import { BsModalRef } from 'ngx-bootstrap';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { Subject } from 'rxjs/Subject';
@Component({
  selector: 'app-create-update-customer',
  templateUrl: './create-update-customer.component.html',
  styleUrls: ['./create-update-customer.component.css']
})
export class CreateUpdateCustomerComponent implements OnInit {

  // customerName:string="";
  // listeUser:any[]=[{
  //   nom:"YAO",
  //   prenom:"Kouassi",
  //   login:"yakou",
  //   contact:"09212109",
  //   statut:'COMMERCANT',
  //   createdAt:"10/10/2010"
  // }];
  // p:number=1
  @Input() customerToUpdate;
  onClose: Subject<boolean> = new Subject<boolean>();
  submitted = false;
  emailPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
  clientFormGroup:FormGroup;
  spinnerLoading = false;
  roles = []
  agences = []
  ng2TelInputOptions: Object;
  dialCode: string;
  connectedUser:any;
  constructor(public httpService:HttpService,private notification:NotificationService,public modalRef:BsModalRef,private formBuilder:FormBuilder) { 
    this.connectedUser = !!JSON.parse(localStorage.getItem('enseigne')) ? JSON.parse(localStorage.getItem('enseigne')) : '';
    this.ng2TelInputOptions = {
      initialCountry: this.connectedUser["CodePays"] ? this.connectedUser["CodePays"].toLowerCase() : 'ci'
    }
  }

  ngOnInit() {
    this.onClose.next(false);
    let contact = this.customerToUpdate ? this.customerToUpdate.Contact.slice(-10) : "";

    this.clientFormGroup = this.formBuilder.group({
      EstClientEntreprise: [this.customerToUpdate ? this.customerToUpdate["EstClientEntreprise"] :true, [Validators.required]],
      EnseigneClientID: this.customerToUpdate ? this.customerToUpdate["EnseigneClientID"] : '',
      NomEntreprise: [this.customerToUpdate ? this.customerToUpdate["NomEntreprise"] : ""],
      Nom: [this.customerToUpdate ? this.customerToUpdate["Nom"] : "", Validators.required],
      Prenoms: [this.customerToUpdate ? this.customerToUpdate["Prenoms"] : "", Validators.required],
      Contact: [this.customerToUpdate ? contact : '', [Validators.required,Validators.maxLength(10)]],
      Adresse: [this.customerToUpdate ? this.customerToUpdate["Adresse"] : ""],
      Description: [this.customerToUpdate ? this.customerToUpdate["Description"] : ""],
      Email:   [this.customerToUpdate ? this.customerToUpdate["Email"] : "",[Validators.email,Validators.required]]
    })

    this.EstClientEntreprise.valueChanges.subscribe(res => {
      this.NomEntreprise.setValue("");
      if(res){
        this.NomEntreprise.setValidators(Validators.required);
      }
      else{
        this.NomEntreprise.setValidators(Validators.nullValidator)
      }
      this.NomEntreprise.updateValueAndValidity();
    });

}
checkPasswords(group: FormGroup) { // here we have the 'passwords' group
let pass = group.controls.Password.value;
let confirmPass = group.controls.ConfirmPassword.value;
return pass === confirmPass ? null : { notSame: true }
}

telInputObject(event) {
  this.dialCode = event.s.dialCode
}

onCountryChange(event) {
  this.dialCode = event.dialCode
}
get EnseigneClientID () {
  return this.clientFormGroup.get('EnseigneClientID');
}
get EstClientEntreprise () {
  return this.clientFormGroup.get('EstClientEntreprise');
}
get NomEntreprise () {
  return this.clientFormGroup.get('NomEntreprise');
}
get Nom() {
  return this.clientFormGroup.get('Nom');
}
get Prenoms() {
  return this.clientFormGroup.get('Prenoms');
}
get Description() {
  return this.clientFormGroup.get('Description');
}
get Contact() {
  return this.clientFormGroup.get('Contact');
}
get Email() {
  return this.clientFormGroup.get('Email');
}
get Adresse() {
  return this.clientFormGroup.get('Adresse');
}
// get ConfirmPassword() {
//   return this.clientFormGroup.get('ConfirmPassword');
// }


createOrUpdateCustomer(){
  this.submitted = true;
  this.spinnerLoading = true;
  
  if(this.clientFormGroup.valid){
    this.clientFormGroup.value.Contact = this.dialCode + this.clientFormGroup.value.Contact;

    const data = {
      ...this.clientFormGroup.value,
    };
    this.httpService
    .execute(!this.EnseigneClientID.value ? 'enseigneClient/create': 'enseigneClient/update', data)
    .subscribe(res => {
      //console.log('create abonne response', res);
      if (!res.HasError) {
        this.notification.smallBox({
          title: "Succès !",
          content: (!this.EnseigneClientID.value ? "Création ": "Modification ")+"effectuée avec succès",
          color: "#35a646",
          timeout: 6000,
          icon: "fa fa-check"
      });
      this.onClose.next(true);
      this.modalRef.hide()
      } else {
        this.notification.smallBox({
        title: "Oops !",
        content: res.Message,
        color: "rgb(159,0,6)",
        timeout: 6000,
        icon: "fa fa-close"
    });
  }
    }, err => {
      this.notification.smallBox({
        title: "Oops !",
        content: err.Message,
        color: "rgb(159,0,6)",
        timeout: 6000,
        icon: "fa fa-close"
    });
    });
  }
  this.spinnerLoading = false;
}

}
